import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { getOverallSettingsClasses, mobileIs } from "../../utils/siteUtils";
import "./style.scss";
const AdaptiveImages = props => {
	const { lang, rendering, fields, page } = props;
  const { pcImage, mobileImage } = fields;
  const isMobile = mobileIs()
  const renderingClass = 'c-section-title' + '_' + rendering.dataSource;

  const rootClasses = classNames("c-adaptive-images", renderingClass, getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource}>
    	{!isMobile && <img src={pcImage?.value?.src} />}
    	{isMobile && <img src={mobileImage?.value?.src} />}
    </div>
  );
};

export default 	AdaptiveImages;